import {ModuleWithProviders, NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {ListFilesComponent} from './list-files/list-files.component';
import {MenuService} from '../menu/menu.service';
import { FilesComponent } from './files.component';
import {RouterModule} from '@angular/router';
import {filesRoutes} from './files.routes';
import { EditFileComponent } from './edit-file/edit-file.component';
import {FormsModule} from '@angular/forms';
import {TagsModule} from '../tags/tags.module';
import {DashboardService} from '../dashboard.service';
import {ApiService} from '../api.service';
import {SearchService} from '../search/search.service';
import {SearchResult, SearchResultItem} from '../search/interface.search';
import {SharedModule} from '../shared/shared.module';

interface File {
    _id?: string;
    title: string;
    filename: string;
    tags: Array<string>;
    added: string;
    filesize: number;
}
const routing: ModuleWithProviders = RouterModule.forRoot(filesRoutes);
@NgModule({
    imports: [
        CommonModule,
        FormsModule,
        TagsModule,
        SharedModule,
        routing
    ],
    declarations: [ListFilesComponent, FilesComponent, EditFileComponent]
})
export class FilesModule {
    constructor(
        protected menuService: MenuService,
        protected dashboardService: DashboardService,
        protected apiService: ApiService,
        protected searchService: SearchService) {
        this.menuService.addMenuItems(
            [
                {
                    name: 'files',
                    path: '/files',
                    icon: 'far fa-file',
                    children: [
                        {
                            name: 'list',
                            path: '/files/list'
                        },
                        {
                            name: 'new',
                            path: '/files/new'
                        }
                    ]
                }]
        );
        this.searchService.getSearchTermSubject().subscribe((val) => {
            this.searchService.addSearchResult('files',
                {title: 'Fetching search result for files ...', items: [], footer: {text: '', buttons: []}, icon: 'far fa-file'});
            this.apiService.search('files', val).subscribe(
                (value: Array<File>) => {
                    const searchResult: SearchResult = {
                        title: 'Files',
                        items: [],
                        footer: {text: '', buttons: [{link: '/files', linkText: 'All files'}]},
                        icon: 'far fa-file'
                    };
                    for (const item of value) {
                        const added = new Date(item.added);
                        const label = item.title + ' (' + item.filename + ') ' +
                            ' , added on: ' + added.toDateString();
                        const resultItem = {
                            label: label,
                            routerLink: ['/files/edit/', item._id],
                            link: '/api/files/download/' + item._id
                        };
                        searchResult.items.push(resultItem);
                    }
                    if (value.length === 0) {
                        searchResult.footer.text = 'No items found';
                    }
                    this.searchService.addSearchResult('files', searchResult);
                });
        });
        this.dashboardService.fetchItems.subscribe((val) => {
            this.dashboardService.addDashboardItem('files',
                {title: 'Files', items: [], footer: {text: '', buttons: []}, icon: 'far fa-file'}
                );
            this.apiService.getAll('files').subscribe(
                (value: any) => {
                    value.sort((a, b) => {
                        return b['added'] > a['added'] ? 1 : -1;
                    });
                    value.length = Math.min(value.length, 10);
                    const dashboardItems: SearchResult = {
                        title: 'Latest files',
                        items: [],
                        footer: {text: '', buttons: [
                            {link: '/files', linkText: 'All files', icon: 'far fa-file'},
                            {link: '/files/new', linkText: 'New file', icon: 'fas fa-plus-circle'}
                            ]},
                        icon: 'far fa-file'
                    };
                    for (let a = 0; a < value.length; a++) {
                        const added = new Date(value[a].added);
                        const label = value[a].title + ' (' + value[a].filename + ') ' +
                            ' , added on: ' + added.toDateString();
                        const resultItem = {
                            label: label,
                            routerLink: ['/files/edit/', value[a]._id],
                            link: '/api/files/download/' + value[a]._id
                        };
                        dashboardItems.items.push(resultItem);
                    }
                    this.dashboardService.addDashboardItem('files', dashboardItems);
                }
            );
        });
    }
}



// WEBPACK FOOTER //
// ./src/app/files/files.module.ts